import React, { Component } from "react";
import NumberFormat from "react-number-format";

class ShippingMethodItem extends Component {
	render() {
		const { option } = this.props;

		return (
			<div>
				{option.name}:{" "}
				<NumberFormat
					displayType="text"
					value={option.price}
					prefix={"$"}
					decimalScale={2}
					fixedDecimalScale={true}
					thousandSeparator={true}
				/>
			</div>
		);
	}
}

export default ShippingMethodItem;



// WEBPACK FOOTER //
// ./src/components/checkout/shipping-payment/ShippingMethodItem.js